// Node imports

import { Container, Label } from "@quest/base-core";
import { FreePlayView } from "@quest/murka-games-behavior-leopard/dist/Game/FreePlay/FreePlayView";

export class FreePlayViewGame extends FreePlayView {
  protected freeplayLabel: Label;
  protected freeplayContainer: Container;
  public initialize() {
    this.freeplayContainer = this.getContainerByID("freePlayMeterContainer");
    this.freeplayLabel = this.getLabelById("freePlayCounterLabel") as Label;
  }
  public updateFreePlaysCount(value: string): void {
    let textUpdated = ingenuity.currentGame.cache.getJSON("lang").freeGames_remainingText.text + " " + value;
    this.freeplayLabel.text = textUpdated;
  }
  public resize() {
    if (!ingenuity.deviceEnv.isDesktop && this.freeplayContainer) {
      this.freeplayContainer.scale.set(
        this.freeplayContainer.json.orientation[ingenuity.deviceEnv.getOrientation()].scale
      );
      this.freeplayContainer.x = this.freeplayContainer.json.orientation[ingenuity.deviceEnv.getOrientation()].x;
      this.freeplayContainer.y = this.freeplayContainer.json.orientation[ingenuity.deviceEnv.getOrientation()].y;
    }
  }
  hide(): void {
    this.freeplayContainer.visible = false;
  }
  show(): void {
    this.freeplayContainer.visible = true;
  }
}
